import { get, writable } from 'svelte/store'

import { browser } from '$app/environment'
import { apiFetchJson, apiGetJson, apiPostJson } from '$lib/proxy/apiProxy'
import type { AccountEventsType } from '$lib/types/client_types'

export const storeEventsNewsCount = writable(0)

const store = writable([] as AccountEventsType[])
export { store as storeAccEventsTypes }

let promiseFetch: Promise<AccountEventsType[]>
let state: 'pending' | 'reading' | 'ready' = 'pending'

// return true if initialized now
export async function InitAccEventsTypes(pFetch = fetch) {
	if (!browser) return fetchData(pFetch)

	if (state === 'ready') return
	if (state === 'reading') {
		await promiseFetch
		return true
	}

	promiseFetch = fetchData(pFetch)
	await promiseFetch
	return true
}

async function fetchData(pFetch = fetch) {
	state = 'reading'

	const jsonData = await apiFetchJson(pFetch, 'get', '/account/events_types')
	if (!jsonData || jsonData.error) {
		state = 'pending'
		return []
	}

	const data = jsonData.account_events_types
	if (browser) {
		store.set(data)
		state = 'ready'
	}

	return data
}

// UP generic ==== Down custom ===================

export const resetEventTypes = () => {
	state = 'pending'
	store.set([])
	storeEventsNewsCount.set(0)
}

export async function fetchAccountEventsNews() {
	if (!browser) return

	const jsonData = await apiGetJson('/events/count/new')
	/*
	 *TPE: Verify why these conditions occur by executing test of dir: 03-estimate/03-01-edit
	 */
	if (jsonData === undefined || jsonData === null) {
		return
	}
	if (jsonData?.error || !jsonData.count) {
		return
	}

	//console.log('account_events_types.ts - storeEventsNewsCount',  json.count);
	storeEventsNewsCount.set(jsonData.count)
}

export async function saveAccountEventsType(accountEventsType: AccountEventsType) {
	await apiPostJson('/account/upsert_events_type', accountEventsType)
}

export function getAccountEventType(eventType_id: number): AccountEventsType | undefined {
	const allAccountEventsTypes = get(store)
	const eventsType = allAccountEventsTypes.find((co) => co.event_type_id === eventType_id)
	if (eventsType) return eventsType

	return undefined
}

export function setAccountEventType(event_type_id: number, enabled: boolean) {
	const accountEventsType = { event_type_id, enabled }

	let allAccountEventsTypes = get(store)
	const eventsType = get(store).find((co) => co.event_type_id === event_type_id)
	if (eventsType === undefined) {
		allAccountEventsTypes = [...allAccountEventsTypes, accountEventsType]
		store.set(allAccountEventsTypes)
	} else {
		store.update((existing) =>
			existing.map((x) => (x.event_type_id !== event_type_id ? x : accountEventsType))
		)
	}

	saveAccountEventsType(accountEventsType)
}
